/* eslint-disable jsx-a11y/alt-text */
import React from "react";

import { Box, Typography, Grid } from "@mui/material";

import Image from "../components/image/Image";
import img1 from "../resources/images/counseling/1.jpg";
import img2 from "../resources/images/counseling/2.jpg";
import img3 from "../resources/images/counseling/3.jpg";
import img4 from "../resources/images/counseling/4.jpg";
import img5 from "../resources/images/counseling/5.jpg";
import img6 from "../resources/images/counseling/6.jpg";
import img7 from "../resources/images/counseling/7.jpg";
import img8 from "../resources/images/counseling/8.jpg";
import img9 from "../resources/images/counseling/9.jpg";
import img10 from "../resources/images/counseling/10.jpg";
import img11 from "../resources/images/counseling/11.jpg";
import img12 from "../resources/images/counseling/12.jpg";

export default function ActivitiesCounseling(props) {
  const nowMediaQuery = props.nowMediaQuery;

  return (
    <div className="section">
      <section className="contents">
        <Box mt={"150px"}>
          <Typography
            variant="h4"
            className="bold"
            textAlign={"center"}
            letterSpacing={2}
            fontSize={25}
            mb={1}
          >
            대화 및 상담
          </Typography>
          <Typography
            variant="subtitle1"
            fontSize={17}
            textAlign={"center"}
            lineHeight={2}
            mb={2}
          >
            “대화와 상담을 통해 지속적인 관심을 기울이고, 신뢰를 바탕으로 소중한
            사회적 관계를 형성합니다.”
          </Typography>
          <Grid container justifyContent={"space-between"} mb={2}>
            <Grid size={{ xs: 12, sm: 12, md: 4 }}>
              <Box
                width={nowMediaQuery !== "mobile" ? "20vw" : "80vw"}
                mb={1}
                pt={0}
              >
                <Image disabledEffect alt={""} src={img1} ratio={"16/9"} />
              </Box>
            </Grid>
            <Grid size={{ xs: 12, sm: 12, md: 4 }}>
              <Box width={nowMediaQuery !== "mobile" ? "20vw" : "80vw"} mb={1}>
                <Image disabledEffect alt={""} src={img2} ratio={"16/9"} />
              </Box>
            </Grid>
            <Grid size={{ xs: 12, sm: 12, md: 4 }}>
              <Box width={nowMediaQuery !== "mobile" ? "20vw" : "80vw"} mb={1}>
                <Image disabledEffect alt={""} src={img3} ratio={"16/9"} />
              </Box>
            </Grid>
          </Grid>
          <Box mt={5}>
            <Typography
              variant="subtitle1"
              fontSize={17}
              textAlign={"center"}
              lineHeight={2}
            >
              대화와 상담을 통해 심리 상태, 질병, 위기 상황 등을 파악하고{" "}
              <strong>적절한 지원</strong>을 제공합니다.
            </Typography>
            <Typography
              variant="subtitle1"
              fontSize={17}
              textAlign={"center"}
              lineHeight={2}
            >
              도움이 필요한 이들을 발견하고, 위급한 상황에는{" "}
              <strong>신속한 지원과 지역 자원 연계</strong>를 제공합니다.
            </Typography>
          </Box>
          {/* </Fade> */}
        </Box>
      </section>

      <section className="contents">
        <div>
          <Typography variant="h5" mb={2}>
            <strong className="blue">의료 지원</strong>
          </Typography>

          <Grid container justifyContent={"space-between"}>
            <Grid size={{ xs: 12, sm: 12, md: 4 }}>
              <Box width={nowMediaQuery !== "mobile" ? "23vw" : "70vw"} mb={1}>
                <Image disabledEffect alt={""} src={img4} ratio={"6/4"} />
              </Box>
            </Grid>
            <Grid size={{ xs: 12, sm: 12, md: 6 }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
                width={nowMediaQuery !== "mobile" ? "40vw" : "80vw"}
                height={"100%"}
              >
                <Typography variant="subtitle1" fontSize={17} sx={{ my: 2 }}>
                  해피인은 지속적인 상담과 대화를 통해 의료 지원이 필요한 분들을
                  파악하고, 연계된 병원을 통해 적절한 치료를 받을 수 있도록
                  지원하고 있습니다.
                  <br />
                  <br />
                  몸과 마음이 아파 병원 방문이 어려운 분들과는 함께 병원에
                  동행하고, 진료 절차를 도와드리며 필요한 안내를 제공합니다.
                  <br />
                  <br />
                  또한, 고독사 위험군에게는 정기적인 전화 연락과 직접 방문을
                  통해 안부를 확인하고 있습니다.
                  <br />
                  <br />
                  이웃의 곁을 지키는 노력들로 사회적 고립을 줄이고, 따뜻한
                  연대감을 형성하고 있습니다.
                  <br />
                </Typography>
              </Box>
            </Grid>
          </Grid>
          <Grid container justifyContent={"space-between"} mb={2}>
            <Grid size={{ xs: 12, sm: 12, md: 6 }}>
              <Box
                width={nowMediaQuery !== "mobile" ? "15vw" : "80vw"}
                mb={1}
                pt={0}
              >
                <Image disabledEffect alt={""} src={img5} ratio={"3/4"} />
              </Box>
            </Grid>
            <Grid size={{ xs: 12, sm: 12, md: 6 }}>
              <Box width={nowMediaQuery !== "mobile" ? "15vw" : "80vw"} mb={1}>
                <Image disabledEffect alt={""} src={img6} ratio={"3/4"} />
              </Box>
            </Grid>
            <Grid size={{ xs: 12, sm: 12, md: 6 }}>
              <Box width={nowMediaQuery !== "mobile" ? "15vw" : "80vw"} mb={1}>
                <Image disabledEffect alt={""} src={img7} ratio={"3/4"} />
              </Box>
            </Grid>
            <Grid size={{ xs: 12, sm: 12, md: 6 }}>
              <Box width={nowMediaQuery !== "mobile" ? "15vw" : "80vw"} mb={1}>
                <Image disabledEffect alt={""} src={img8} ratio={"3/4"} />
              </Box>
            </Grid>
          </Grid>
        </div>
      </section>
      <section className="contents">
        <div>
          <Typography variant="h5" mb={2}>
            <strong className="blue">커뮤니티 공간 '해피친구들'</strong>
          </Typography>

          <Grid container justifyContent={"space-between"}>
            <Grid size={{ xs: 12, sm: 12, md: 4 }}>
              <Box width={nowMediaQuery !== "mobile" ? "23vw" : "70vw"} mb={1}>
                <Image disabledEffect alt={""} src={img9} ratio={"6/4"} />
              </Box>
            </Grid>
            <Grid size={{ xs: 12, sm: 12, md: 6 }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
                width={nowMediaQuery !== "mobile" ? "40vw" : "80vw"}
                height={"100%"}
              >
                <Typography variant="subtitle1" fontSize={17} sx={{ my: 2 }}>
                  해피인 가족들에게 상담. 운동. 프로그램. 교육. 소모임 활동.
                  전시 및 회의를 위한 공간을 제공하고 있습니다.
                </Typography>
              </Box>
            </Grid>
          </Grid>
          <Grid container justifyContent={"space-between"} mb={2}>
            <Grid size={{ xs: 12, sm: 12, md: 6 }}>
              <Box
                width={nowMediaQuery !== "mobile" ? "20vw" : "80vw"}
                mb={1}
                pt={0}
              >
                <Image disabledEffect alt={""} src={img10} ratio={"4/3"} />
              </Box>
            </Grid>
            <Grid size={{ xs: 12, sm: 12, md: 6 }}>
              <Box width={nowMediaQuery !== "mobile" ? "20vw" : "80vw"} mb={1}>
                <Image disabledEffect alt={""} src={img11} ratio={"4/3"} />
              </Box>
            </Grid>
            <Grid size={{ xs: 12, sm: 12, md: 6 }}>
              <Box width={nowMediaQuery !== "mobile" ? "20vw" : "80vw"} mb={1}>
                <Image disabledEffect alt={""} src={img12} ratio={"4/3"} />
              </Box>
            </Grid>
          </Grid>
        </div>
      </section>
    </div>
  );
}
